import connectionProxy from './connectionProxy'

export const getConsumptionMap = ({ year, areaId }) => {
  return connectionProxy.http.get(`/mapas_de_consumo?areaId=${areaId}&year=${year}`)
}

export const getConsumptionMapItem = (id = '') => {
  return connectionProxy.http.get(`/item_mapa_de_consumo/${id}`)
}

export const getYearList = (areaId) => {
  return connectionProxy.http.get(`/mapas_de_consumo/anos?term=${areaId}`)
}

export const getAreaList = () => {
  return connectionProxy.http.get(`/mapas_de_consumo/areas`)
}



// WEBPACK FOOTER //
// ./src/api/consumptionMap.js